module.exports = __webpack_public_path__ + "img/IconoTazas.adebb22e.png";